<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>防汛控制点</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加控制点</el-button>
      <div class="import-s">
      	<p class>
      		<span class="el-icon-upload2"></span>导入
      	</p>
      	<input type="file" @change="xzdata($event)" />
      </div>
      <el-button class="titBtn" type="success" icon="el-icon-download" @click="download">模板下载</el-button>
			<!-- <el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button> -->
			<!-- <el-input class="querys" v-model.trim="dw" placeholder="值班表标题"></el-input> -->
      <addressTree @obj="objdata" @close="treeClose"></addressTree>
		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align="center" width="45" label="序号"></el-table-column>
				<el-table-column prop="ydbName" align="center" label="控制点名称"></el-table-column>
				<el-table-column prop="ydbSfsw" align="center" label="设防水位"></el-table-column>
				<el-table-column prop="ydbJjsw" align="center" label="警戒水位"></el-table-column>
				<el-table-column prop="ydbBzsw" align="center" label="保证水位"></el-table-column>
				<el-table-column prop="ydbDqsw" align="center" label="当前水位"></el-table-column>
				<el-table-column prop="ydbWxzs" align="center" label="危险指数"></el-table-column>
        <el-table-column prop="ydbShiJian" align="center" label="时间"></el-table-column>
				<el-table-column label="操作" width="90" align="center">
					<template slot-scope="scope">
						<el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edits(scope.$index,scope.row)"></el-button>
						<el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.$index,scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
		</div>

		<controlpointpopup v-if="dialogVisible == true" :mystate="Addsid" @bjadddata="Bjadddata" @getcancel="Getcancel" @adddata="Adddata"></controlpointpopup>
	</div>
</template>

<script>
  import { kzdList, kzdDelete } from "@/api/api";
  import addressTree from '@/components/mangement/addressTree.vue';
	import pagintion from '@/components/mangement/pagintion.vue';
	import controlpointpopup from '../popup/controlpointpopup.vue'
  import axios from "axios";
  import Url from '@/common/js/Url.js';
	export default{
		data(){
			return{
				dw:'',
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 1, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
			}
		},

		components: {
      addressTree,
			pagintion,
			controlpointpopup
		},
		mounted() {
      let params = {
      	pageSize: this.pageSize,
      	pageNum: this.pageNum,
      }
      this.list(params);
		},
		methods: {
      //调用接口获得防汛管理制度列表
      list(params) {
      	kzdList(params).then((res) => {
          this.total = res.total;
          this.tabledata = res.data;
      	})
      },
			Getcancel(data) {
				this.dialogVisible = data.dialogVisible;
			},
			addClick(){
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('xz');
			},
      edits(index, row) {
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('bj', row);
      },
      deletes(index, row) {
      	this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
      		confirmButtonText: '确定',
      		cancelButtonText: '取消',
      		type: 'warning'
      	}).then(action => {
      		if(action === 'confirm') {
            let ids = [];
            ids.push(row.id);
      			kzdDelete(ids).then((res) => {
      				if(res.code == 200) {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      					let params = {
      						pageSize: this.pageSize,
      						pageNum: this.pageNum,
      					}
      					this.list(params);
      				} else {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      				}
      			})
      		}
      	}).catch(() => {
      		this.$message({
      			message: '已取消',
      			type: 'warning'
      		});
      	});
      },
      treeClose() {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }
        this.list(params)
      },
      objdata(data) {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbCode: data.ydbCode
        }
        this.list(params)
      },
			Bjadddata(data){
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
			},
			Adddata(data){
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
			},
      rowClick(row) {
        this.row = row;
      },
      reset() {
        this.dw = '';
      },
      DsyData(data) { //多少页
      	this.pageNum = data.dsy;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,
      	}
        this.list(params)
      },
      DstData(data) { //多少条
      	this.pageSize = data.dst;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,
      	}
        this.list(params)
      },

      //模板下载
      download() {
      	window.location.href = '/userApi/fx/kzd/export';
      },

      //控制点导入
      xzdata(e) {
      	let file = e.target.files[0];
      	let filename = file.name.split(".")[
      		file.name.split(".").length - 1
      	];
      	let filenames = file.name;
      	let fileSize = file.size / 1024 / 1024 < 1000000;
      	if(fileSize) {
      		if(filename != "xlsx") {
      			this.$notify({
      				title: "提示",
      				message: "请选择xls文件",
      				type: "success",
      			});
      			e.target.value = null;
      		} else {
      			let formData = new FormData();
      			formData.append("file", file);
      			let config = {
      				headers: {
      					"Content-Type": "multipart/form-data",
      				},
      			}; // 添加请求头
      			axios.post("/importfile/fx/kzd/import", formData, config).then((res) => {
      				if(res.data.code == 200) {
      					this.$notify({
      						title: "提示",
      						message: res.data.message,
      						type: "success",
      					});
      					let params = {
      						pageSize: this.pageSize,
      						pageNum: this.pageNum,
      					};
      					this.list(params);
      					e.target.value = null;
      				} else {
      					this.$notify({
      						title: "提示",
      						message: res.data.message,
      						type: "warning",
      					});
      				}
      			}).catch((err) => {});
      		}
      	} else {
      		this.$message({
      			message: "文件不能大于10M",
      			type: "success",
      		});
      		e.target.value = null;
      	}
      },
		},
	}
</script>

<style scoped>
	@import url('../../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}

	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;
		font-size: 14px;
	}

  .import-s {
  	float: right;
  	position: relative;
  	width: 100px;
  	height: 28px;
  	background: #409eff;
  	margin-right: 10px;
  	border-radius: 4px;
  	margin-top: 11px;
  	overflow: hidden;
  }

  .import-s p {
  	position: absolute;
  	width: 100%;
  	line-height: 28px;
  	text-align: center;
  	font-size: 14px;
  	color: #fff;
  	cursor: pointer;
  }

  .import-s p span {
  	margin-right: 5px;
  }

  .import-s input {
  	width: 100%;
  	height: 28px;
  	position: absolute;
  	opacity: 0;
  	cursor: pointer;
  }
</style>
